/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from 'react'

interface FeedbackStateProps {
  isOpen:boolean
  message:string
  statusOk:boolean
}

const initialFeedback:FeedbackStateProps = {
  isOpen:false,
  message:'',
  statusOk:false
}

interface FeedbackContextProps {
  feedback:FeedbackStateProps
  setFeedback:React.Dispatch<React.SetStateAction<FeedbackStateProps>>
}

export const FeedbackContext = createContext<FeedbackContextProps>({
  feedback: initialFeedback,
  setFeedback: () => {}
})

export const FeedbackProvider: React.FC<any> = ({ children }) => {
  const [feedback, setFeedback] = useState(initialFeedback)

  return (
    <FeedbackContext.Provider
      value={{
        feedback,
        setFeedback
      }}
    >
      {children}
    </FeedbackContext.Provider>
  )
}
